import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener,
         Inject, OnInit, ViewChild, ViewRef, OnDestroy } from '@angular/core';

import { PlaceholderType
       } from 'collage-designer/stage/placeholder/placeholder';
import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { TextPlaceholder
       } from 'collage-designer/stage/placeholder/text-placeholder';
import { ProductService } from 'core/product/product.service';
import { EventTrackingService } from 'core/tracking/event-tracking.service';
import { Utils } from 'core/utils';
import { StageUtils } from 'core/utils.stage';
import { Subscription } from 'rxjs';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
    selector: 'text-toolbox',
    templateUrl: './text-toolbox.component.html',
    styleUrls: ['./text-toolbox.component.scss', '../toolbox.component.scss'],
    standalone: false
})
export class TextToolboxComponent extends ToolboxComponent
    implements OnDestroy
{
  public placeholder: TextPlaceholder;
  public isSmallDevice: boolean = false;
  public isBoxTitle: boolean = false;

  protected name: string = 'TextToolbox';

  private subscriptions: Subscription = new Subscription();

  constructor(
      private elRef: ElementRef,
      @Inject(ToolboxService) toolboxService,
      @Inject(ProductService) private productService: ProductService,
      @Inject(PlaceholderService) private placeholderService:
          PlaceholderService,
      @Inject(EventTrackingService) private eventTrackingService:
          EventTrackingService)
  {
    super(toolboxService);
    this.isSmallDevice = !Utils.isLargeDevice();
    this.subscriptions.add(
        this.placeholderService.focusedPlaceholderChanged.subscribe(p => {
          if (p instanceof TextPlaceholder) {
            this.initialize();
          }
          else {
            this.placeholder = undefined;
          }
        }));
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
  }

  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  public onResize(): void
  {
    this.isSmallDevice = !Utils.isLargeDevice();
  }

  protected respondToCloseRequest(): void
  {
    if (this.isSmallDevice) {
      this.btnCloseClick();
    }
    else {
      this.btnBackClick();
    }
  }

  public btnCloseClick(): void
  {
    super.btnCloseClick();
    this.placeholderService.setFocusedPlaceholder(undefined);
  }

  public btnBackClick(): void
  {
    this.btnCloseClick();
    if (!this.placeholderService.getSoleTextPlaceholder()) {
      this.toolboxService.open('TextEditToolbox');
    }
  }

  private initialize(): void
  {
    const pl = this.placeholderService.getFocusedPlaceholder();
    this.placeholder = pl as unknown as TextPlaceholder;
    const componentType = StageUtils.getComponentType(
        this.placeholder.element.root());
    this.isBoxTitle = StageUtils.isBoxTitle(
        componentType, this.placeholder.element.attr('id'));
  }
}
